import { Button, Tooltip } from "antd";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { ZCatalogRecordAction } from "src/business/records/ZCatalogRecord";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { SelectWorkflowModal } from "./SelectWorkflowModal";

type PropsRecordCardActions = {
  actions?: ZCatalogRecordAction[] | null;
  catalogId: string;
  catalogCardId: string;
};

type ActionBase<T extends ZCatalogRecordAction["type"]> = Extract<
  ZCatalogRecordAction,
  { type: T }
>;

type ActionCtx<T extends ZCatalogRecordAction["type"]> = ActionBase<T> & {
  catalogId: string;
  catalogCardId: string;
};

const WorkflowAssignAction: React.FC<ActionCtx<"workflowAssign">> = ({
  disabled,
  catalogId,
  catalogCardId,
}) => {
  const navigate = useNavigate();
  const [wfModalOpen, setWfModalOpen] = React.useState(false);

  return (
    <>
      <Tooltip
        title={
          disabled
            ? "Недостаточно прав для погружения записи в рабочий поток"
            : "Изменение записи через рабочий поток"
        }
      >
        <Button disabled={disabled} onClick={() => setWfModalOpen(true)}>
          Погрузить в РП
        </Button>
      </Tooltip>

      {wfModalOpen && (
        <SelectWorkflowModal
          open={wfModalOpen}
          catalogId={catalogId}
          catalogCardId={catalogCardId}
          onClose={() => setWfModalOpen(false)}
          onSuccess={(wfCardId) => {
            setWfModalOpen(false);
            navigate(makeUrl(PageUrl.editRecordWf, { id: wfCardId }));
          }}
        />
      )}
    </>
  );
};

const RedirectToWfCardAction: React.FC<ActionBase<"redirectToWfCard">> = ({
  disabled,
  workflowCardId,
}) => (
  <Tooltip title={disabled ? "Нет прав для просмотра рабочей версии" : null}>
    <Button
      href={makeUrl(PageUrl.editRecordWf, { id: workflowCardId })}
      target="_blank"
      rel="noopener noreferrer"
      disabled={disabled}
    >
      Открыть рабочую версию
    </Button>
  </Tooltip>
);

const renderAction = (
  action: ZCatalogRecordAction,
  actionCtx: Pick<ActionCtx<"workflowAssign">, "catalogCardId" | "catalogId">,
) => {
  switch (action.type) {
    case "workflowAssign":
      return <WorkflowAssignAction {...action} {...actionCtx} />;
    case "redirectToWfCard":
      return <RedirectToWfCardAction {...action} />;
    default:
      return null;
  }
};

const getActionKey = (action: ZCatalogRecordAction, index: number) =>
  `${action.type}:${index}`;

export const RecordCardActions: React.FC<PropsRecordCardActions> = ({
  actions,
  catalogId,
  catalogCardId,
}) => {
  const actionCtx = { catalogId, catalogCardId };
  return (
    actions?.map((action, index) => (
      <React.Fragment key={getActionKey(action, index)}>
        {renderAction(action, actionCtx)}
      </React.Fragment>
    )) ?? null
  );
};
